import { mapGetters } from 'vuex'

export default {
    mixins: [],
    computed: {
        ...mapGetters(['expenseRules']),
        usableExpenseRules() {
            let rules =
                this.expenseRules?.filter(
                    (rule) =>
                        !!this.$cart.calculation.usable_expense_rules?.find(
                            (usableRules) => usableRules.id === rule.id
                        )
                ) || []

            if (this.$cart.selected_expense_rule) {
                const id = Number.parseInt(this.$cart.selected_expense_rule.split('/').pop())
                rules = rules.filter((rule) => rule.id === id)
            }

            return rules
        },

        hasBudget() {
            return (
                !this.$cart.payment_method &&
                this.usableExpenseRules.length &&
                this.remainBudget > 0
            )
        },

        remainBudget() {
            return this.biggerAllowance - this.$cart.calculation.price_sum
        },

        biggerAllowance() {
            let rules = this.usableExpenseRules

            if (!rules.length) {
                return null
            }

            const budgets = rules.map((rule) => rule.budget)
            return Math.max(...budgets)
        },
    },
}
